const actions = {
  SET_USER_DATA: "auth/SET_USER_DATA",
  CLEAR_ALL_STORAGE_DATA: "auth/CLEAR_ALL_STORAGE_DATA",
  SET_TOKEN: "auth/SET_TOKEN",
  SET_ACCOUNT_TAB: "auth/SET_ACCOUNT_TAB",
  SET_ACTIVE_VALUE: "auth/SET_ACTIVE_VALUE",
  PROPOSAL_DETAILS: "auth/PROPOSAL_DETAILS",
  RESET_PROPOSAL_DETAILS: "auth/RESET_PROPOSAL_DETAILS",
  SET_ERRORS: "auth/SET_ERRORS",
  RESET_ERRORS: "auth/RESET_ERRORS",
  SET_USER_UUID: "auth/SET_USER_UUID",
  SET_NOTI_DATA: "auth/SET_NOTI_DATA",
  SET_DISPLAY_NOTIFICATION_POP_UP: "auth/SET_DISPLAY_NOTIFICATION_POP_UP",
  SET_RELOAD: "auth/SET_RELOAD",
  SET_ONBOARDING_DISMISSED: "auth/SET_ONBOARDING_DISMISSED",
  SET_CONTRACTOR_ROLES: "auth/SET_CONTRACTOR_ROLES",
  SET_USER_ROLE_WITH_PERMISSIONS: "auth/SET_USER_ROLE_WITH_PERMISSIONS",

  setUserData: (userdata) => (dispatch) =>
    dispatch({
      type: actions.SET_USER_DATA,
      userdata,
    }),

  setProposalDetails: (proposalDetails) => (dispatch) =>
    dispatch({
      type: actions.PROPOSAL_DETAILS,
      proposalDetails,
    }),

  resetProposalDetails: () => (dispatch) =>
    dispatch({
      type: actions.RESET_PROPOSAL_DETAILS
    }),

  setErrors: (errors) => (dispatch) =>
    dispatch({
      type: actions.SET_ERRORS,
      errors,
    }),
  resetErrors: (errors) => (dispatch) =>
    dispatch({
      type: actions.RESET_ERRORS,
      errors,
    }),

  setToken: (token) => (dispatch) =>
    dispatch({
      type: actions.SET_TOKEN,
      token,
    }),

  setUserUUID: (useruuid) => (dispatch) =>
    dispatch({
      type: actions.SET_USER_UUID,
      useruuid,
    }),

  displayNotificationPopUp: (isNotify) => (dispatch) =>
    dispatch({
      type: actions.SET_DISPLAY_NOTIFICATION_POP_UP,
      isNotify,
    }),

  setNotiData: (notiData) => (dispatch) =>
    dispatch({
      type: actions.SET_NOTI_DATA,
      notiData,
    }),

  setReload: (reload) => (dispatch) =>
    dispatch({
      type: actions.SET_RELOAD,
      reload,
    }),

  setAccountTab: (accountTab) => (dispatch) =>
    dispatch({
      type: actions.SET_ACCOUNT_TAB,
      accountTab,
    }),

  setActiveValue: (activeValue) => (dispatch) =>
    dispatch({
      type: actions.SET_ACTIVE_VALUE,
      activeValue,
    }),

  clearAllData: () => (dispatch) =>
    dispatch({
      type: actions.CLEAR_ALL_STORAGE_DATA,
    }),

  setOnboardingDismissed: (userId, isDismissed) => (dispatch) =>
    dispatch({
      type: actions.SET_ONBOARDING_DISMISSED,
      userId,
      isDismissed,
    }),

  setContractorRoles: (roles) => (dispatch) =>
    dispatch({
      type: actions.SET_CONTRACTOR_ROLES,
      roles,
    }),

  setUserRoleWithPermissions: (roleWithPermissions) => (dispatch) =>
    dispatch({
      type: actions.SET_USER_ROLE_WITH_PERMISSIONS,
      roleWithPermissions,
    }),
};

export default actions;
